function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M55.918 17H30.082C24.514 17 20 21.514 20 27.082v25.836C20 58.486 24.514 63 30.082 63h25.836C61.486 63 66 58.486 66 52.918V27.082C66 21.514 61.486 17 55.918 17z",
  fill: "url(#paint0_linear)"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M26.301 42.257c0 4.9 3.985 8.9 9.18 8.9.958 0 1.79-.175 2.345-.4.656.6 1.59 1.375 2.32 1.9 1.917 1.35 4.01 2.15 6.305 2.15 1.135 0 2.194-.2 2.875-.375v-2.675c-.656.175-1.337.225-1.992.225-1.387 0-2.825-.4-4.388-1.3-.63-.4-1.21-.825-1.816-1.325 1.715-1.25 3.581-3.725 3.581-7.1 0-4.9-3.984-8.874-9.23-8.874-5.195 0-9.18 3.975-9.18 8.874zm3.682 0c0-3.2 2.472-5.8 5.498-5.8 3.051 0 5.548 2.6 5.548 5.8 0 3.2-2.497 5.8-5.548 5.8-3.026 0-5.498-2.6-5.498-5.8z",
  fill: "#fff"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M49.256 44.307h.832c.152 0 .303 0 .48-.025 1.059 2.125 3.253 5.2 4.362 6.55h4.767c-2.169-1.975-4.06-4.925-6.028-7.124 1.816-.575 3.405-1.95 3.405-4.65 0-3.1-2.27-5.35-6.406-5.35h-5.17c.076.75.127 2.775.127 4.475v8.224c0 1.7-.05 3.65-.127 4.425h3.859c-.076-.775-.1-2.725-.1-4.425v-2.1zm0-7.75h1.236c1.942 0 2.925 1.25 2.925 2.6 0 1.5-1.134 2.576-2.774 2.576h-1.387v-5.175z",
  fill: "#fff"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M51.347 17s-15.122 8.034-15.595 25.835C24.337 35.685 23.91 23.54 24.21 18.889c.372-.272.934-.699 2.506-1.328 1.393-.516 2.982-.561 2.982-.561h21.65z",
  fill: "url(#paint1_linear)"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M82.235 39.84c0 5.344 4.299 9.708 9.903 9.708 1.034 0 1.932-.191 2.53-.437a30.58 30.58 0 002.503 2.073c2.068 1.473 4.326 2.345 6.802 2.345a12.77 12.77 0 003.101-.409v-2.918c-.707.191-1.442.246-2.149.246-1.496 0-3.047-.437-4.734-1.418a19.02 19.02 0 01-1.959-1.446c1.85-1.363 3.863-4.063 3.863-7.745 0-5.345-4.298-9.68-9.957-9.68-5.604 0-9.903 4.335-9.903 9.68zm3.972 0c0-3.491 2.667-6.328 5.931-6.328 3.292 0 5.986 2.837 5.986 6.327 0 3.491-2.694 6.327-5.986 6.327-3.264 0-5.93-2.836-5.93-6.327z",
  fill: "#111"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  d: "M108.58 43.712v-4.418c0-.736.054-1.963.108-2.754h-4.298c-.218.654-.571 1.609-.898 2.154h1.333v5.481c0 3.437 1.85 5.264 4.462 5.264 1.659 0 2.802-.573 3.7-1.91.027.71.19 1.31.381 1.664h3.645c-.299-.627-.435-1.5-.435-2.836v-7.063c0-.736.027-1.963.109-2.754h-3.945c.082.79.109 2.018.109 2.754v4.39c0 1.964-1.088 2.755-2.122 2.755-.952 0-2.149-.627-2.149-2.727zM123.719 39.294c0-.982.027-2.154.081-2.754h-4.271c-.19.654-.571 1.663-.898 2.154h1.333v7.718c0 .954-.054 2.209-.108 2.782h3.944c-.054-.519-.081-1.773-.081-2.782v-7.118zm-3.945-6.627c0 1.146.898 2.073 2.04 2.073 1.143 0 2.041-.927 2.041-2.073 0-1.172-.898-2.1-2.041-2.1-1.142 0-2.04.928-2.04 2.1zM129.692 42.894c0-1.854 1.442-3.382 3.265-3.382 1.306 0 2.013.437 2.639 1.037v-3.955c-.762-.027-1.66-.3-2.721-.3-3.972 0-6.855 2.946-6.855 6.6 0 3.573 2.856 6.49 6.855 6.49 1.361 0 1.878-.19 2.83-.3v-4.008c-.599.627-1.388 1.118-2.748 1.118-1.823 0-3.265-1.5-3.265-3.3zM141.955 31.93c0-.872.027-2.126.109-2.753h-4.326c-.163.6-.571 1.609-.843 2.154h1.333v15.108c0 .9-.027 2.154-.109 2.754h3.945c-.054-.6-.109-1.772-.109-2.754v-2.782c3.319 4.037 4.081 4.936 4.489 5.536h4.707c-1.415-1.445-2.095-2.181-5.849-6.872 2.965-4.036 3.672-4.881 4.434-5.781h-3.945c-.462.818-.87 1.445-3.836 5.454V31.93zM162.199 42.076h.899c.163 0 .326 0 .517-.027 1.141 2.318 3.509 5.672 4.706 7.145h5.142c-2.34-2.155-4.38-5.373-6.503-7.773 1.959-.627 3.674-2.127 3.674-5.072 0-3.382-2.449-5.836-6.911-5.836h-5.577c.081.818.137 3.027.137 4.881v8.973c0 1.854-.056 3.981-.137 4.827h4.163c-.083-.846-.11-2.973-.11-4.827v-2.291zm0-8.454h1.334c2.095 0 3.155 1.363 3.155 2.836 0 1.636-1.224 2.809-2.992 2.809h-1.497v-5.645zM185.34 43.576c.054-.164.081-.6.081-.955 0-3.082-2.285-6.3-6.039-6.3-3.455 0-6.121 2.864-6.121 6.573 0 3.681 2.829 6.517 6.747 6.517 2.095 0 3.128-.545 4.027-.6v-3.163c-1.034.627-1.959.818-3.402.818-1.932 0-3.264-1.282-3.563-2.89h8.27zm-5.958-4.555c1.306 0 2.013 1.01 2.177 2.018h-4.543c.353-1.2 1.142-2.018 2.366-2.018zM190.836 39.84c0-.519.326-.955 1.251-.955.762 0 2.394.464 2.993 1.31v-3.41c-.68-.054-1.795-.49-3.183-.49-3.074 0-4.788 1.445-4.788 3.845 0 3.9 4.761 4.063 4.761 5.672 0 .6-.463.982-1.252.982-1.116 0-3.02-.818-3.754-1.746v3.736c.734.082 2.422.737 3.999.737 3.128 0 4.761-1.664 4.761-3.982 0-4.036-4.788-4.172-4.788-5.7zM198.495 33.158c.054.654.081 1.554.081 2.454v.927h-1.822v3.082h1.822v4.936c0 3.436 2.096 4.854 4.516 4.854.98 0 1.688-.163 2.204-.163V46.03c-.19.19-.761.273-1.141.273-1.09 0-1.851-.655-1.851-2.482v-4.2h3.374V36.54h-3.374v-.927c0-.927.027-1.8.081-2.454h-3.89zM206.851 42.867c0 3.6 2.992 6.518 6.691 6.518 3.673 0 6.693-2.918 6.693-6.518 0-3.654-3.02-6.573-6.693-6.573-3.699 0-6.691 2.946-6.691 6.573zm3.563 0c0-1.855 1.36-3.327 3.128-3.327 1.714 0 3.13 1.472 3.13 3.327 0 1.827-1.416 3.272-3.13 3.272-1.768 0-3.128-1.445-3.128-3.272z",
  fill: "#111"
});

var _ref8 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: 43,
  y1: 17,
  x2: 43,
  y2: 63,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#FA154C"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#FF001F"
})), React.createElement("linearGradient", {
  id: "paint1_linear",
  x1: 37.749,
  y1: 17,
  x2: 37.749,
  y2: 42.835,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#00A3FF"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#148EFF"
})));

var SvgQuickresto = function SvgQuickresto(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 240 80",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgQuickresto, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/quickresto.82fe86d3.svg";
export { ForwardRef as ReactComponent };